import { Box, Image } from "@chakra-ui/react";

interface ImageCardProps {
  image: string;
  title: string;
  images: ImageItem[];
}

interface ImageItem {
  image: string;
  title: string;
  value: string;
}

function ImageCard({ image, title }: ImageCardProps) {
  return (
    <Box
      maxW="10rem"
      border="1px solid"
      borderColor="primary.100"
      p="0.5rem"
      borderRadius="md"
      m="1rem"
    >
      <Image maxH="1px" overflow="hidden" src={image} alt={title} />
    </Box>
  );
}

export default ImageCard;
